export default "__VITE_ASSET__X6Q2I9MV__"